import {
    createMountsGlazingGasketConfig,
    createMountsCGFFrameVerticalConfig,
    createMountsCGFFrameHorizontalConfig,
    createMountsCGFChannelVerticalConfig,
    createMountsCGFChannelHorizontalConfig,
} from "../../base";

import { MountsService } from "@/app/services/mounts.service";
import { IComponentConfig } from "@/app/@types/base-component";
import { Partition } from "@/app/domain/entities/partition";

const createSwingDoorMountsCGFFrameVerticalConfig = (
    partition: Partition,
): IComponentConfig => {
    const length = MountsService.getCGFFrameVertical(partition);

    return createMountsCGFFrameVerticalConfig().qty(0).area(length).build();
};

const createSwingDoorMountsCGFFrameHorizontalConfig = (
    partition: Partition,
): IComponentConfig => {
    const length = MountsService.getCGFFrameHorizontal(partition);

    return createMountsCGFFrameHorizontalConfig().qty(0).area(length).build();
};

const createSwingDoorMountsCGFChannelVerticalConfig = (
    partition: Partition,
): IComponentConfig => {
    const length = MountsService.getCGFChannelVertical(partition);

    return createMountsCGFChannelVerticalConfig().qty(0).area(length).build();
};

const createSwingDoorMountsCGFChannelHorizontalConfig = (
    partition: Partition,
): IComponentConfig => {
    const length = MountsService.getCGFChannelHorizontal(partition);

    return createMountsCGFChannelHorizontalConfig().qty(0).area(length).build();
};

const createSwingDoorMountsGlazingGasketConfig = (
    partition: Partition,
): IComponentConfig => {
    const totalWidth = MountsService.getTotalWidth(partition);
    const totalHeight = MountsService.getTotalHeight(partition);
    const doorWidth = MountsService.getDoorTotalWidth(partition);
    const hasTransom = MountsService.hasOverdoorTransom(partition);

    const sides = 2;
    const transomMultiplier = hasTransom ? 1 : sides;

    const totalDoorWidth = doorWidth * transomMultiplier;//top and bottom sides
    const horizontalGaskets = totalWidth * sides - totalDoorWidth;//top and bottom sides
    const verticalGaskets = totalHeight * sides;//left and right sides

    const qty = Math.round((horizontalGaskets + verticalGaskets) * sides) || 0; //inner and outer sides

    return createMountsGlazingGasketConfig().qty(0).area(qty).build();
};

export const CGF300SwingDoorsConfigs = (partition: Partition) => [
    createSwingDoorMountsCGFFrameVerticalConfig(partition),
    createSwingDoorMountsCGFFrameHorizontalConfig(partition),
    createSwingDoorMountsCGFChannelVerticalConfig(partition),
    createSwingDoorMountsCGFChannelHorizontalConfig(partition),
    createSwingDoorMountsGlazingGasketConfig(partition),
];
